import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {mergeMap} from 'rxjs';
import {ApiService} from '../services/api/api.service';
import {Constants} from '../constants/constants';

const GUEST_AUTH_ENDPOINTS = ['/shared-links/'];

export const guestTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const requiresGuestAuth = GUEST_AUTH_ENDPOINTS.some(endpoint => req.url.includes(endpoint));

  if (requiresGuestAuth) {
    const apiService = inject(ApiService);
    return apiService.getGuestToken().pipe(
      mergeMap((tokenResponse: any) => {
        const modifiedReq = req.clone({
          setHeaders: {
            Authorization: `${Constants.BEARER_PREFIX}${tokenResponse.token}`,
          },
        });
        return next(modifiedReq);
      }),
    );
  }
  return next(req);
};
